import { createPortal } from "react-dom";

export default function DeleteAccountModal({
  deleteAccountTarget,
  onCancel,
  onRemove,
  theme,
}) {
  if (!deleteAccountTarget || typeof document === "undefined") return null;
  const title = "Remover plataforma";
  const text = "Essa plataforma tem valor preenchido. Tem certeza que deseja remover?";

  return createPortal(
    <div
      className="delete-modal-backdrop delete-modal-backdrop--account"
      data-theme={theme}
      role="presentation"
      onClick={onCancel}
    >
      <section
        className="delete-modal delete-modal--account"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-account-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="delete-account-title" className="delete-modal__title">
          {title}
        </h2>
        <p className="delete-modal__text">{text}</p>
        <div className="delete-modal__actions">
          <button className="btn-ghost" type="button" onClick={onCancel}>
            Cancelar
          </button>
          <button
            className="btn-red"
            type="button"
            onClick={() => onRemove(deleteAccountTarget)}
          >
            Remover
          </button>
        </div>
      </section>
    </div>,
    document.body
  );
}
